export default "__VITE_ASSET__U34ZYih___"